import { Subject } from "rxjs";

const CannedMessageSummarySubject = new Subject();

const CannedMessageSummaryService = {
  listen: () => CannedMessageSummarySubject.asObservable(),
  fetchCannedMessageCounts: () => CannedMessageSummarySubject.next(),
};

export default CannedMessageSummaryService;
